import React from 'react'
import resume from '../files/resume.pdf'
function Resume() {
  return (
    <div>
        <div data-aos="fade-up"
        data-aos-duration="1000"
     data-aos-anchor-placement="bottom-bottom" className='flex mb-[40px] justify-center items-center '> 
        <a href={resume} className=' bg-green-600 text-white hover:bg-green-800 hover:text-white transition-all py-2 px-4 rounded-md' download={"habibur-rahman-front-developer-resume"} target={"_blank"}>Download Resume</a>
        </div>
        <div  data-aos="fade-up"
     data-aos-duration="2000">
            <iframe className='rounded-md max-w-[800px] mx-auto' src={resume} title="HABIB" height="900px" width="100%" />
        </div>
    </div>
  )
}

export default Resume